import classes from './SugestedPatients.module.css'
import Button from '../../../../common/Button'
import { addRelatedPatient, removeSugestedRelatedPatient } from '../../../../../lib/fetchApi'
import { notificationActions } from '../../../../../store/notifications'
import { caseActions } from '../../../../../store/case'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { formatDateLocal } from '../../../../../lib/script'

export default function SugestedPatientItem({itemData, readOnly}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 
    const [loading, setLoading] = useState(false)
    const [removeLoading, setRemoveLoading] = useState(false)

    const addrelatedPatientHandler = async () => {        
        setLoading(true)
        try {
            let reqBody = {
                related_patients: [itemData?.suggested_case_id]
            }        

            let update = await addRelatedPatient(userToken, activeCase.case.id, reqBody, dispatch)

            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))            
            } else {
                let dispatchBody = {
                    folder: 'related_patients',
                    arr: update
                }
                dispatch(caseActions.replaceFolder(dispatchBody))
            } 
        } finally {
            setLoading(false)
        }
    }

    async function removePatientHandler() {
        setRemoveLoading(true)
        try {
            let reqBody = {
                occupant_id: [itemData?.id]
            }        

            let update = await removeSugestedRelatedPatient(userToken, activeCase.case.id, reqBody, dispatch)

            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))            
            } else {
                let dispatchBody = {
                    folder: 'police_report_occupants',
                    itemId: itemData?.id
                }
                dispatch(caseActions.removeFromArray(dispatchBody))
            }
        } finally {
            setRemoveLoading(false)
        }
    }

    return (
        <div key={itemData.id} className={classes.item}>
            <h5>{formatDateLocal(itemData.incident_date)} - {itemData.name}</h5>
            {!readOnly && <div className={classes.buttons}>
                <Button btnStyle="btn_small" click={addrelatedPatientHandler} isLoading={loading}>Add</Button>
                <Button btnStyle="btn_small" click={removePatientHandler} isLoading={removeLoading}>Remove</Button>
            </div>}
        </div>
    )
}